// extracted by mini-css-extract-plugin
export default {"container":"dwNJh","sliderWrapper":"a5sPt","slider":"zaTiw","valuePreview":"RFmnf","triangleDown":"wlnWq","infos":"Ps17W","limits":"kfV_i","details":"_og0e","ticks":"MRYNi"};